const CovidDataJuly = [
  {
    id: 1,
    fullyVaxed: 0,
    oneBooster: 0,
    twoBooster: 0,
    beyondBooster: 0,
    ageRange: '0-4'
  },
  {
    id: 2,
    fullyVaxed: 227115,
    oneBooster: 20310,
    twoBooster: 10000,
    beyondBooster: 0,
    ageRange: '5-11'
  },
  {
    id: 3,
    fullyVaxed: 146057,
    oneBooster: 86698,
    twoBooster: 325,
    beyondBooster: 0,
    ageRange: '12-15'
  },
  {
    id: 4,
    fullyVaxed: 131917,
    oneBooster: 132408,
    twoBooster: 912,
    beyondBooster: 0,
    ageRange: '16-19'
  },
  {
    id: 5,
    fullyVaxed: 411130,
    oneBooster: 337593,
    twoBooster: 4663,
    beyondBooster: 0,
    ageRange: '20-29'
  },
  {
    id: 6,
    fullyVaxed: 373205,
    oneBooster: 397747,
    twoBooster: 9143,
    beyondBooster: 0,
    ageRange: '30-39'
  },
  {
    id: 7,
    fullyVaxed: 290620,
    oneBooster: 394825,
    twoBooster: 14006,
    beyondBooster: 0,
    ageRange: '40-49'
  },
  {
    id: 8,
    fullyVaxed: 298357,
    oneBooster: 424535,
    twoBooster: 106366,
    beyondBooster: 1093,
    ageRange: '50-59'
  },
  {
    id: 9,
    fullyVaxed: 124469,
    oneBooster: 215906,
    twoBooster: 83716,
    beyondBooster: 740,
    ageRange: '60-64'
  },
  {
    id: 10,
    fullyVaxed: 89330,
    oneBooster: 173089,
    twoBooster: 105261,
    beyondBooster: 916,
    ageRange: '65-69'
  },
  {
    id: 11,
    fullyVaxed: 67076,
    oneBooster: 131368,
    twoBooster: 103902,
    beyondBooster: 741,
    ageRange: '70-74'
  },
  {
    id: 12,
    fullyVaxed: 119234,
    oneBooster: 211714,
    twoBooster: 170639,
    beyondBooster: 755,
    ageRange: '75+'
  }
]

export default CovidDataJuly
